/**
 * GraphQL queries for Shopify collections
 */

/**
 * Query to get a collection by ID
 */
export const GET_COLLECTION = `
  query GetCollection(
    $id: ID,
    $handle: String,
    $productLimit: Int = 20,
    $sortKey: ProductCollectionSortKeys = MANUAL,
    $reverse: Boolean = false,
    $filters: [ProductFilter!],
    $cursor: String
  ) {
    collection(id: $id, handle: $handle) {
      id
      title
      description
      handle
      updatedAt
      seo {
        title
        description
      }
      image {
        id
        url
        altText
        width
        height
      }
      metafields(identifiers: [
        {namespace: "custom", key: "mobile_banner"},
        {namespace: "custom", key: "collection_banner_image"},
        {namespace: "custom", key: "collection_redirection"},
      ]) {
        namespace
        key
        value
        reference {
          ... on MediaImage {
            image {
              url
              altText
            }
          }
        }
      }
      products(
        first: $productLimit,
        sortKey: $sortKey,
        reverse: $reverse,
        filters: $filters,
        after: $cursor
      ) {
        filters {
          id
          label
          type
          values {
            id
            label
            input
            count
          }
        }
        nodes {
          id
          title
          description
          handle
          productType
          vendor
          tags
          createdAt
          updatedAt
          publishedAt
          availableForSale

          metafields(
            identifiers: [
              { namespace: "reviews", key: "rating" },
              { namespace: "reviews", key: "rating_count" },
              { namespace: "custom", key: "byline" },
              { namespace: "custom", key: "product_subtitle" },
              { namespace: "custom", key: "product_net_content" },
              { namespace: "custom", key: "product_labels" }
            ]
          ) {
            key
            namespace
            value
            type
          }

          options {
            id
            name
            values
          }
          variants(first: 20) {
            nodes {
              id
              title
              sku
              availableForSale
              selectedOptions {
                name
                value
              }
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              image {
                id
                url
                altText
                width
                height
              }
            }
          }

          totalInventory
          onlineStoreUrl
          featuredImage {
            url
            altText
            id
          }

          images(first: 10) {
            nodes {
              id
              url
              altText
              width
              height
            }
          }

          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }

          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

/**
 * Query to get collections
 */
export const GET_COLLECTIONS = `
  query GetCollections(
    $first: Int,
    $last: Int,
    $after: String,
    $before: String,
    $query: String,
    $sortKey: CollectionSortKeys,
    $reverse: Boolean
  ) {
    collections(
      first: $first,
      last: $last,
      after: $after,
      before: $before,
      query: $query,
      sortKey: $sortKey,
      reverse: $reverse
    ) {
      nodes {
        id
        title
        description
        handle
        updatedAt
        seo {
          title
          description
        }
        image {
          id
          url
          altText
          width
          height
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
